import { FONT_BASE, INK, LINE_HEIGHT_BASE } from '../themeConstants'

export const muiComponentsBaseline = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        color: INK.primary,
        fontFamily: 'var(--app-font-sans)',
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE,
      },
    },
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontFamily: 'inherit',
        fontSize: FONT_BASE,
        lineHeight: LINE_HEIGHT_BASE,
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        subtitle1: 'p',
        subtitle2: 'p',
        body1: 'p',
        body2: 'p',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
}
